import React, {useEffect} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {IFormProps} from "@pg-mono/form";
import {hitUserSegmentBudget, hitUserSegmentOfferTypeDefault, hitUserSegmentRooms} from "@pg-mono/google-tag-manager";
import {FILTERS_TEST_IDS} from "@pg-mono/test-ids";
import {Currency} from "@pg-rp/common-types";

import {useOfferListingHolidayView} from "../../offer/list/hooks/use_offer_listing_holiday_view_check";
import {hitFiltersInteraction} from "../../real_estate/tracking/hit_filters_interaction";
import {convertSearchFormToFiltersTracking} from "../../real_estate/utils/convert_search_form_to_filters_tracking";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {ISearchFiltersSlot} from "../types/ISearchFiltersSlot";
import {IRealEstateFiltersConfig} from "../types/RealEstateFiltersConfig";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {validateFilterError} from "../utils/filters/validate_filter";
import {saveRecentFilters} from "../utils/recent_filters_storage";
import {FilterFooter} from "./filters/SearchFiltersFooter";
import {RealEstateFilters} from "./generic_filters/RealEstateFilters";
import {RecentFiltersSidebar} from "./RecentFiltersSidebar";

interface IProps {
    searchFiltersSlots: ISearchFiltersSlot[];
    searchFiltersCountBySlots?: Record<string, number>;
    legacyFormProps: IFormProps<ISearchFiltersFormValues>;
    setDesktopFilterBlendActive?: (isOpen: boolean) => void;
    onMobileCloseModal?: (makeGtmHit?: boolean) => void;
    onMobileResetForm?: () => void;
    topContent?: React.ReactNode;
    isInModal?: boolean;
    isAbroad?: boolean;
    filtersConfig: IRealEstateFiltersConfig;
}

export const MobileSearchFilters = (props: IProps) => {
    const {
        searchFiltersSlots,
        searchFiltersCountBySlots,
        legacyFormProps,
        setDesktopFilterBlendActive,
        onMobileCloseModal,
        onMobileResetForm,
        topContent,
        isAbroad,
        filtersConfig
    } = props;

    const isHoliday = useOfferListingHolidayView();

    useEffect(() => {
        hitFiltersInteraction("open", convertSearchFormToFiltersTracking(legacyFormProps.values as SearchFormValuesType));
    }, []);

    const closeMobileModal = () => {
        setDesktopFilterBlendActive && setDesktopFilterBlendActive(false);
        onMobileCloseModal && onMobileCloseModal();
    };

    const submitMobileModal = (e: React.MouseEvent<HTMLElement>) => {
        if (validateFilterError(legacyFormProps.values, searchFiltersSlots)) {
            // prevent form submission if there is a validation error
            return;
        }
        const currentFilters = legacyFormProps.values as SearchFormValuesType;

        hitFiltersInteraction("apply", convertSearchFormToFiltersTracking(currentFilters));

        hitUserSegmentOfferTypeDefault(currentFilters.type as (number | string)[] | undefined | null);
        hitUserSegmentBudget({priceUpper: currentFilters.price?.upper, instalment: currentFilters.instalment});
        hitUserSegmentRooms(currentFilters.rooms ?? {});

        if (!isAbroad && !isHoliday) {
            // save recent filters only for polish offers
            saveRecentFilters(currentFilters);
        }

        closeMobileModal();
        legacyFormProps.onSubmit && legacyFormProps.onSubmit(e);
    };

    return (
        <div className={filtersHolder}>
            <div className={filtersScroller}>
                <RecentFiltersSidebar />

                {topContent}
                <RealEstateFilters
                    formValues={legacyFormProps.values}
                    filtersConfig={filtersConfig}
                    filtersSlots={searchFiltersSlots}
                    legacyFormProps={legacyFormProps}
                    currency={isAbroad ? Currency.EURO : Currency.PLN}
                    filterRender={(filterSlot, filter) => (
                        <div key={filterSlot.id} className={css({py: 2, px: 3})}>
                            <Text
                                as="div"
                                variant="body_copy_2"
                                className={css({display: "flex", alignItems: "center", pr: 1, mb: 2})}
                                data-testid={
                                    filterSlot.label === "Metraż"
                                        ? FILTERS_TEST_IDS.AREA
                                        : filterSlot.label === "Termin oddania"
                                          ? FILTERS_TEST_IDS.DELIVERY_DATE
                                          : undefined
                                }
                            >
                                {filterSlot.label}

                                {searchFiltersCountBySlots?.[filterSlot.id] ? (
                                    <span className={css({ml: 0.5, color: "var(--colors-danger)"})}>({searchFiltersCountBySlots?.[filterSlot.id]})</span>
                                ) : null}
                            </Text>
                            <div>{filter}</div>
                        </div>
                    )}
                />
            </div>

            <div className={mobileFiltersFooterWrapper}>
                <FilterFooter
                    onCancel={onMobileResetForm || (() => null)}
                    onSave={(e: React.MouseEvent<HTMLElement>) => {
                        submitMobileModal(e);
                    }}
                />
            </div>
        </div>
    );
};

const filtersHolder = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden",

    md: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexGrow: 1,
        flexShrink: 1,
        width: "50%",
        height: "unset",

        "& > div:nth-of-type(3)": {
            mr: 0
        }
    }
});

const filtersScroller = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflowY: "auto",

    md: {
        flexDirection: "row",
        overflowY: "initial"
    }
});

const mobileFiltersFooterWrapper = css({
    width: "100%",
    display: "block",
    px: 3,
    pb: 2,

    md: {
        display: "none"
    }
});
import React, {useEffect} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {IFormProps} from "@pg-mono/form";
import {hitUserSegmentBudget, hitUserSegmentOfferTypeDefault, hitUserSegmentRooms} from "@pg-mono/google-tag-manager";
import {FILTERS_TEST_IDS} from "@pg-mono/test-ids";
import {Currency} from "@pg-rp/common-types";

import {useOfferListingHolidayView} from "../../offer/list/hooks/use_offer_listing_holiday_view_check";
import {hitFiltersInteraction} from "../../real_estate/tracking/hit_filters_interaction";
import {convertSearchFormToFiltersTracking} from "../../real_estate/utils/convert_search_form_to_filters_tracking";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {ISearchFiltersSlot} from "../types/ISearchFiltersSlot";
import {IRealEstateFiltersConfig} from "../types/RealEstateFiltersConfig";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {validateFilterError} from "../utils/filters/validate_filter";
import {saveRecentFilters} from "../utils/recent_filters_storage";
import {FilterFooter} from "./filters/SearchFiltersFooter";
import {RealEstateFilters} from "./generic_filters/RealEstateFilters";
import {RecentFiltersSidebar} from "./RecentFiltersSidebar";

interface IProps {
    searchFiltersSlots: ISearchFiltersSlot[];
    searchFiltersCountBySlots?: Record<string, number>;
    legacyFormProps: IFormProps<ISearchFiltersFormValues>;
    setDesktopFilterBlendActive?: (isOpen: boolean) => void;
    onMobileCloseModal?: (makeGtmHit?: boolean) => void;
    onMobileResetForm?: () => void;
    topContent?: React.ReactNode;
    isInModal?: boolean;
    isAbroad?: boolean;
    filtersConfig: IRealEstateFiltersConfig;
}

export const MobileSearchFilters = (props: IProps) => {
    const {
        searchFiltersSlots,
        searchFiltersCountBySlots,
        legacyFormProps,
        setDesktopFilterBlendActive,
        onMobileCloseModal,
        onMobileResetForm,
        topContent,
        isAbroad,
        filtersConfig
    } = props;

    const isHoliday = useOfferListingHolidayView();

    useEffect(() => {
        hitFiltersInteraction("open", convertSearchFormToFiltersTracking(legacyFormProps.values as SearchFormValuesType));
    }, []);

    const closeMobileModal = () => {
        setDesktopFilterBlendActive && setDesktopFilterBlendActive(false);
        onMobileCloseModal && onMobileCloseModal();
    };

    const submitMobileModal = (e: React.MouseEvent<HTMLElement>) => {
        if (validateFilterError(legacyFormProps.values, searchFiltersSlots)) {
            // prevent form submission if there is a validation error
            return;
        }
        const currentFilters = legacyFormProps.values as SearchFormValuesType;

        hitFiltersInteraction("apply", convertSearchFormToFiltersTracking(currentFilters));

        hitUserSegmentOfferTypeDefault(currentFilters.type as (number | string)[] | undefined | null);
        hitUserSegmentBudget({priceUpper: currentFilters.price?.upper, instalment: currentFilters.instalment});
        hitUserSegmentRooms(currentFilters.rooms ?? {});

        if (!isAbroad && !isHoliday) {
            // save recent filters only for polish offers
            saveRecentFilters(currentFilters);
        }

        closeMobileModal();
        legacyFormProps.onSubmit && legacyFormProps.onSubmit(e);
    };

    return (
        <div className={filtersHolder}>
            <div className={filtersScroller}>
                <RecentFiltersSidebar />

                {topContent}
                <RealEstateFilters
                    formValues={legacyFormProps.values}
                    filtersConfig={filtersConfig}
                    filtersSlots={searchFiltersSlots}
                    legacyFormProps={legacyFormProps}
                    currency={isAbroad ? Currency.EURO : Currency.PLN}
                    filterRender={(filterSlot, filter) => (
                        <div key={filterSlot.id} className={css({py: 2, px: 3})}>
                            <Text
                                as="div"
                                variant="body_copy_2"
                                className={css({display: "flex", alignItems: "center", pr: 1, mb: 2})}
                                data-testid={
                                    filterSlot.label === "Metraż"
                                        ? FILTERS_TEST_IDS.AREA
                                        : filterSlot.label === "Termin oddania"
                                          ? FILTERS_TEST_IDS.DELIVERY_DATE
                                          : undefined
                                }
                            >
                                {filterSlot.label}

                                {searchFiltersCountBySlots?.[filterSlot.id] ? (
                                    <span className={css({ml: 0.5, color: "var(--colors-danger)"})}>({searchFiltersCountBySlots?.[filterSlot.id]})</span>
                                ) : null}
                            </Text>
                            <div>{filter}</div>
                        </div>
                    )}
                />
            </div>

            <div className={mobileFiltersFooterWrapper}>
                <FilterFooter
                    onCancel={onMobileResetForm || (() => null)}
                    onSave={(e: React.MouseEvent<HTMLElement>) => {
                        submitMobileModal(e);
                    }}
                />
            </div>
        </div>
    );
};

const filtersHolder = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden",

    md: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexGrow: 1,
        flexShrink: 1,
        width: "50%",
        height: "unset",

        "& > div:nth-of-type(3)": {
            mr: 0
        }
    }
});

const filtersScroller = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflowY: "auto",

    md: {
        flexDirection: "row",
        overflowY: "initial"
    }
});

const mobileFiltersFooterWrapper = css({
    width: "100%",
    display: "block",
    px: 3,
    pb: 2,

    md: {
        display: "none"
    }
});
